module.exports = __webpack_public_path__ + "static/media/icon-14.7aac8924.png";